/* Bureau Supply — cart drawer over Shopify's AJAX Cart API */
(function () {
  "use strict";

  var scrim = document.getElementById("scrim");
  var drawer = document.getElementById("drawer");
  var lines = document.getElementById("lines");
  var countEl = document.getElementById("count");
  var subEl = document.getElementById("subtotal");
  var checkoutEl = document.getElementById("checkout");

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function openCart() {
    scrim.classList.add("on");
    drawer.classList.add("on");
  }
  function shutCart() {
    scrim.classList.remove("on");
    drawer.classList.remove("on");
  }

  function render(cart) {
    if (countEl) countEl.textContent = cart.item_count;
    if (subEl) subEl.textContent = money(cart.total_price);
    if (!lines) return;

    if (!cart.items.length) {
      lines.innerHTML = '<p class="empty">Nothing here yet.</p>';
      if (checkoutEl) checkoutEl.style.opacity = ".5";
      return;
    }
    if (checkoutEl) checkoutEl.style.opacity = "";

    lines.innerHTML = cart.items
      .map(function (l) {
        var variant = l.variant_title ? " · " + l.variant_title : "";
        return (
          '<div class="line">' +
          "<strong>" + l.product_title + variant + "</strong>" +
          '<span class="m">' + money(l.line_price) + "</span>" +
          '<span class="m">Qty ' + l.quantity + "</span>" +
          '<button class="rm" data-key="' + l.key + '">Remove</button>' +
          "</div>"
        );
      })
      .join("");
  }

  function fetchCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart.js" : "/cart.js", {
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { /* cart unavailable — leave the drawer as-is */ });
  }

  function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // --- add to cart (progressive enhancement over a real <form>) ---
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[action*='/cart/add']");
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector("[type=submit]");
    var label = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }

    var data = new FormData(form);
    var payload = { id: data.get("id"), quantity: Number(data.get("quantity") || 1) };

    post("/cart/add.js", payload)
      .then(function () { return fetchCart(); })
      .then(function () {
        openCart();
        if (btn) { btn.disabled = false; btn.textContent = label; }
      })
      .catch(function () {
        // If the AJAX route fails for any reason, fall back to a normal submit.
        form.submit();
      });
  });

  // --- remove a line ---
  document.addEventListener("click", function (e) {
    var rm = e.target.closest(".rm");
    if (!rm) return;
    lines.classList.add("busy");
    post("/cart/change.js", { id: rm.dataset.key, quantity: 0 })
      .then(render)
      .then(function () { lines.classList.remove("busy"); })
      .catch(function () { lines.classList.remove("busy"); });
  });

  // --- drawer open/close ---
  var openBtn = document.getElementById("opencart");
  var closeBtn = document.getElementById("closecart");
  if (openBtn) openBtn.onclick = function () { fetchCart().then(openCart); };
  if (closeBtn) closeBtn.onclick = shutCart;
  if (scrim) scrim.onclick = shutCart;
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") shutCart();
  });

  // --- theme toggle ---
  var themeBtn = document.getElementById("theme");
  if (themeBtn) {
    try {
      var saved = localStorage.getItem("bs-theme");
      if (saved) document.documentElement.setAttribute("data-theme", saved);
    } catch (err) {}
    themeBtn.onclick = function () {
      // Light is the default: no data-theme attribute means light, whatever
      // the visitor's OS preference is. Dark is only ever opt-in.
      var r = document.documentElement;
      var dark = r.getAttribute("data-theme") === "dark";
      var next = dark ? "light" : "dark";
      r.setAttribute("data-theme", next);
      try { localStorage.setItem("bs-theme", next); } catch (err) {}
    };
  }

  // --- product page: wood selector + quantity ---
  var opts = document.getElementById("opts");
  if (opts) {
    opts.addEventListener("click", function (e) {
      var b = e.target.closest(".opt");
      if (!b || b.disabled) return;
      [].slice.call(opts.children).forEach(function (o) {
        o.setAttribute("aria-pressed", String(o === b));
      });
      var id = b.dataset.variant;
      var idField = document.getElementById("variant-id");
      if (idField) idField.value = id;
      var priceEl = document.getElementById("variant-price");
      if (priceEl && b.dataset.price) priceEl.textContent = b.dataset.price + " USD";
      var addBtn = document.getElementById("addfeat");
      if (addBtn && b.dataset.price) addBtn.textContent = "Add to cart — " + b.dataset.price;
      var url = new URL(window.location.href);
      url.searchParams.set("variant", id);
      history.replaceState({}, "", url);
    });
  }

  var q = document.getElementById("q");
  var qField = document.getElementById("quantity-field");
  var minus = document.getElementById("minus");
  var plus = document.getElementById("plus");
  if (q && minus && plus) {
    var n = 1;
    var sync = function () {
      q.value = n;
      q.textContent = n;
      if (qField) qField.value = n;
    };
    minus.onclick = function () { n = Math.max(1, n - 1); sync(); };
    plus.onclick = function () { n = n + 1; sync(); };
    sync();
  }

  fetchCart();
})();


/* ---------- v2 ---------- */
(function(){var b=document.getElementById('menu'),n=document.getElementById('nav');if(!b||!n)return;b.addEventListener('click',function(){var o=n.classList.toggle('open');b.setAttribute('aria-expanded',o?'true':'false');});})();
(function(){var f=document.getElementById('rv-form');if(!f)return;var hid=document.getElementById('rv-rating');var stars=[].slice.call(f.querySelectorAll('.stars button'));function paint(v){stars.forEach(function(s,i){if(i<v){s.classList.add('on');s.textContent='\u2605';}else{s.classList.remove('on');s.textContent='\u2606';}});}stars.forEach(function(s,i){s.addEventListener('click',function(e){e.preventDefault();hid.value=String(i+1);paint(i+1);});});paint(parseInt(hid.value,10)||5);f.addEventListener('submit',function(){var t=f.querySelector('textarea[name="comment[body]"]');var p=document.getElementById('rv-product');var pv=p?p.value:'';if(t&&t.value.indexOf('[[')!==0){t.value='[['+hid.value+'|'+pv+']] '+t.value;}});})();
